import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { currentPollsStyle as styles } from './currentPolls.tailwind';
// import Spinner from '../../../../shared/Loaders/Spinner';
import PollList from '../../../shared/Polls/PollList';
import noPollsIcon from '../../../../../assets/svgs/no_polls.svg';
import PollSkeleton from '../../../shared/Skeletons/PollSkeleton/PollSkeleton';

const CurrentPolls = () => {
  const { currentPolls, isCurrentPollsLoading } = useSelector((state) => state.earnPoint ?? {});
  const { user } = useSelector((state) => state.user ?? {});
  const userId = user?.userDetails?._id;

  const [expandedPolls, setExpandedPolls] = useState([0]);

  const togglePoll = (index) => {
    setExpandedPolls(prev => {
      const isCurrentlyExpanded = prev.includes(index);
      if (isCurrentlyExpanded) {
        return prev.filter(pollIndex => pollIndex !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const handlePollSubmit = (index) => {
    setExpandedPolls(prev => {
      if (!prev.includes(index)) {
        return [...prev, index];
      }
      return prev;
    });
  };

  return (
    <div className={styles.outerContainer}>
      <span className={styles.heading}>
        <span>Current Polls</span>
        {/* <div className={`${styles.dividerContainer}`}>
          <div className={`${styles.divider} w-[30px] md:w-[50px]`}></div>
          <div className={`${styles.divider} w-[10px] md:w-[30px]`}></div>
          <div className={`${styles.divider} w-[5px] md:w-[25px]`}></div>
        </div> */}
      </span>

      {isCurrentPollsLoading ? (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <PollSkeleton count={4}/>
        </div>
      ) : currentPolls?.length === 0 ? (
        <div className={styles.noPollsContainer}>
          <img
            src={noPollsIcon}
            alt="No polls"
            className={styles.noPollsImage}
          />
            <p className={styles.noPollsText}>No current polls found</p>
        </div>
      ) : (
        <div className={styles.pollDataContainer}>
          {currentPolls?.map((poll, index) => (
            <PollList
              key={index}
              poll={poll}
              index={index}
              userId={userId}
              isExpanded={expandedPolls.includes(index)}
              togglePoll={togglePoll}
              onPollSubmit={handlePollSubmit}
              isLivePoll={false}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CurrentPolls;